import { NavItems, TabItems } from "@/domains/profile/types";
import { Gift, History, User } from "lucide-react";

export const NAV_ITEMS_DATA: NavItems = [
  {
    link: "profile",
    href: "/profile/edit",
    icon: User,
  },
  {
    link: "promotions",
    href: "/profile/promotions",
    icon: Gift,
  },
  /*   {
    link: "verification",
    href: "/profile/verification",
    icon: BadgeCheck,
  }, */
  {
    link: "history",
    href: "/profile/history",
    icon: History,
  },
  /*   {
    link: "limits",
    href: "/profile/limits",
    icon: Hand,
  }, */
];

export const TAB_EDIT_ITEMS_DATA: TabItems = [
  {
    link: "tab1",
    href: "#tab1",
  },
  {
    link: "tab2",
    href: "#tab2",
  },
];

export const TAB_HISTORY_ITEMS_DATA: TabItems = [
  { link: "tab1", href: "#tab1" },
  { link: "tab2", href: "#tab2" },
];
